<template>
  <div
    class="relative max-h-[calc(100vh-320px)] animate-pulse overflow-y-auto rounded-md"
    style="border: 1px solid rgba(31, 36, 46, 0.14)"
  >
    <div
      class="sticky top-0 z-20 grid grid-cols-24 bg-steel-100 text-left text-sm text-gray-700"
      style="border-bottom: 1px solid rgba(31, 36, 46, 0.14)"
    >
      <div
        v-for="i in 12"
        :key="i"
        :class="colClass[i - 1]"
        class="p-2"
      >
        <div class="h-4 w-3/4 rounded bg-steel-200" />
      </div>
    </div>

    <div class="h-[calc(100vh-650px)] overflow-y-auto">
      <div
        v-for="i in 20"
        :key="i"
        class="grid grid-cols-24 items-center whitespace-nowrap border-b border-steel-100 p-2 text-left text-sm text-gray-900"
      >
        <div
          v-for="j in 12"
          :key="j"
          :class="colClass[j - 1]"
          class="px-2 py-1"
        >
          <div class="h-4 w-full rounded bg-steel-100" />
        </div>
      </div>
    </div>

    <div
      class="topShadow sticky bottom-0 z-20 flex h-14 items-center justify-center border-t bg-white px-3 py-2 text-sm font-normal text-gray-900"
    >
      <div class="h-6 w-32 rounded bg-steel-200" />
    </div>
  </div>
</template>

<script setup>
const colClass = [
  'col-span-1',
  'col-span-2',
  'col-span-4',
  'col-span-1',
  'col-span-2',
  'col-span-4',
  'col-span-3',
  'col-span-3',
  'col-span-2',
  'col-span-2',
  'hidden',
  'hidden',
];
</script>

<style scoped>
.topShadow {
  box-shadow: 0px -1px 6px 0px rgba(160, 160, 160, 0.22);
}
</style>
